import styled from 'styled-components';

export default styled.div`
  padding: 25px 30px;
  width: 100%;

`;
